import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "mb-2 text-sm font-medium text-gray-700" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500"
}

import InputField from '@/components/neue/InputField.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { dropLabel, sectionCopy } from '@/config/dropWizardSteps'


export default {
  __name: 'StepWhat',
  props: { stores: { type: Array, default: () => [] } },
  setup(__props) {


const wizard = injectWizard()

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('details', _unref(wizard).data))), {
    default: _withCtx(() => [
      _createVNode(InputField, {
        modelValue: _unref(wizard).data.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.name) = $event)),
        name: "Name",
        placeholder: "e.g. Fall Harvest Box",
        autofocus: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, "Which store sells " + _toDisplayString(_unref(dropLabel)(_unref(wizard).data)) + "?", 1),
        _createVNode(SelectionGroup, { label: "Store" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stores, (store) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: store.id,
                compact: "",
                name: groupName,
                title: store.name,
                subtitle: `${store.status} · ${store.productCount} products`,
                selected: _unref(wizard).data.storeId === store.id,
                onSelect: $event => (_unref(wizard).data.storeId = store.id)
              }, null, 8, ["name", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }),
        (!__props.stores.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Create a store first, then come back to set up a drop."))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 16))
}
}

}